import { createContext, useContext } from 'react';
import { getCurrentLanguage } from 'helpers/Utils';

export interface SettingsState {
  locale: string;
}

export type SettingsAction = { type: 'SET_LOCALE'; payload: string };

export const initialState = (): SettingsState => ({
  locale: getCurrentLanguage(),
});

export const settingsReducer = (
  state: SettingsState,
  action: SettingsAction
): SettingsState => {
  switch (action.type) {
    case 'SET_LOCALE':
      return { ...state, locale: action.payload };
    default:
      return state;
  }
};

export const SettingsContext = createContext<{
  state: SettingsState;
  dispatch: React.Dispatch<SettingsAction>;
} | undefined>(undefined);

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettings must be used within a SettingsProvider');
  }
  const { state, dispatch } = context;

  const setLocale = (locale: string) => {
    dispatch({ type: 'SET_LOCALE', payload: locale });
  };

  return {
    locale: state.locale,
    setLocale,
  };
};
